import { createFileRoute } from '@tanstack/react-router'

// Bare /jobs (no job selected): JobsLayout renders the full-width rail with its SlideInPanel closed, so
// this index match renders nothing into the (collapsed) detail Outlet. Selecting a job navigates to
// `/jobs/$jobId/report`.
export const Route = createFileRoute('/_app/jobs/_list/')({})
